import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IReportDateRangePicker, ISignature, ReportStatus } from '@shared/interfaces';
import { ReportBuilderService } from '../../services/report-builder.service';
import { DialogService } from '../../../../shared/services/dialog.service';
import { ReportGetter } from '../../directives/ReportGetter';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NavigationService } from '../../../../shared/services/navigation.service';
import { GuardService } from '@shared/services';
import { ModuleService } from '../../../../shared/services/module.service';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../../../current-project';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-report-side-info',
    templateUrl: './report-side-info.component.html',
    styleUrls: ['./report-side-info.component.scss'],
    standalone: false
})
export class ReportSideInfoComponent extends ReportGetter implements OnInit {
    IS_TRS_PROJECT = IS_TRS_PROJECT;
    IS_PRODUCT_SAFETY_PROJECT = IS_PRODUCT_SAFETY_PROJECT;

    @Output() signature = new EventEmitter<string>();

    protected dateRangePickerFormGroup: FormGroup<IReportDateRangePicker>;

    constructor(
        private dialogService: DialogService,
        builder: ReportBuilderService,
        dialog: MatDialog,
        router: Router,
        navigation: NavigationService,
        guard: GuardService,
        moduleService: ModuleService
    ) {
        super(builder, dialog, router, navigation, guard, moduleService);
    }

    ngOnInit() {
        this.buildForm();

        if (window.innerWidth <= 1120) {
            setTimeout(() => (this.burgerOpen = true), 600);
        }

        if (IS_PRODUCT_SAFETY_PROJECT && this.isResponsibleForReport) {
            this.openResponsibleInfoDialog();
        }
    }

    get radius(): number {
        return document.getElementById('pie-chart').clientWidth - 60;
    }

    get isResponsibleForReport(): boolean {
        return !!this.report?.responsible.responsible?.find(r => r.id === this.guard.currentUser.id);
    }

    private buildForm(): void {
        this.dateRangePickerFormGroup = new FormGroup<IReportDateRangePicker>({
            reportStartDate: new FormControl(
                { value: new Date(this.reportStartDate), disabled: true },
                Validators.required
            ),
            reportEndDate: new FormControl({ value: new Date(this.reportEndDate), disabled: true }, Validators.required)
        });
    }

    protected dateRangePickerChanged(): void {
        this.reportStartDate = this.dateRangePickerFormGroup.controls.reportStartDate.value;
        this.reportEndDate = this.dateRangePickerFormGroup.controls.reportEndDate.value;
    }

    signAsResponsible() {
        const project = IS_TRS_PROJECT
            ? this.translateService.instant('project.trs.name')
            : this.translateService.instant('project.product-safety.name');
        const projectAbbreviation = IS_TRS_PROJECT
            ? this.translateService.instant('project.trs.abbreviation')
            : this.translateService.instant('project.product-safety.abbreviation');
        const title = this.translateService.instant('report-side-info.title-responsible');
        const message = this.translateService.instant('report-side-info.description-responsible', {
            project,
            projectAbbreviation
        });
        this.dialogService.openDialog({ title, message }).subscribe(e => {
            if (e) {
                this.report.responsibleSignature = {};
                this.builder.calculateDoc();
                if (this.report.specialistSignature) {
                    this.report.reportStatus = ReportStatus.released;
                }
                this.signature.emit('responsible');
            }
        });
    }

    singleSignatureResult(signature: ISignature | ISignature[]): ISignature {
        return signature as ISignature;
    }

    openResponsibleInfoDialog(): void {
        let title = '';
        if (this.report?.doc === 1) {
            title = this.translateService.instant('report-side-info.dialogData.responsible-message.1');
        }
        if (this.report?.doc < 1 && this.report?.doc >= 0.95) {
            title = this.translateService.instant('report-side-info.dialogData.responsible-message.2');
        }
        if (this.report?.doc < 0.95) {
            title = this.translateService.instant('report-side-info.dialogData.responsible-message.3');
        }
        this.dialogService.openDialog({ message: title, hideCancelButton: true, confirmText: 'OK' }).subscribe();
    }
}
